import { domain } from 'modules/data';
import { hocs as pageHocs } from 'modules/page';
import { memo } from 'react';
import { Redirect } from 'react-router-dom';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';
import { getPath, Path } from 'urlBuilder';

import { pageConfig } from './config';

export const Page = memo(() => {
    const company = useCompanyBasedOnUrl();

    return <Redirect to={getPath(Path.reportsDashboard, company.id, domain.ReportType.Request)} />;
});

export default pageHocs.withProtected({ Page, roles: pageConfig.access });
